// List of verified email domains that are allowed to sign up
export const ALLOWED_EMAIL_DOMAINS = [
  // Educational institutions (US)
  "edu",
  "ac.edu",

  // Educational institutions (UK)
  "ac.uk",
  "sch.uk",

  // Educational institutions (Canada)
  "ac.ca",

  // Educational institutions (Australia)
  "edu.au",

  // Educational institutions (New Zealand)
  "ac.nz",

  // Educational institutions (South Africa)
  "ac.za",

  // Educational institutions (India)
  "ac.in",
  "edu.in",

  // Government domains (US)
  "gov",
  "mil",

  // Government domains (UK)
  "gov.uk",
  "nhs.uk",

  // Government domains (Canada)
  "gc.ca",

  // Government domains (Australia)
  "gov.au",

  // Government domains (New Zealand)
  "govt.nz",

  // Government domains (South Africa)
  "gov.za",

  // Government domains (India)
  "gov.in",
  "nic.in",

  // Research institutions
  "org",
  "research",

  // Corporate domains (add your trusted partners)
  "ps752justice.com",

  // Major Email Services (well-established, reputable)
  "gmail.com",
  "outlook.com",
  "hotmail.com",
  "yahoo.com",
  "icloud.com",
  "protonmail.com",
  "tutanota.com",

  // Personal domains (if you want to allow specific ones)
  // 'yourdomain.com',
  // 'trusted-partner.org',

  // Development/testing (REMOVE IN PRODUCTION)
  "localhost",
  "test.com",
  "example.com",
  "newme.social", // Your own domain
];

// Function to check if an email domain is allowed
export const isEmailDomainAllowed = (email: string): boolean => {
  const domain = email.split("@")[1]?.toLowerCase();
  if (!domain) return false;

  return ALLOWED_EMAIL_DOMAINS.some((allowedDomain) => {
    // Exact match for full domains
    if (allowedDomain.includes(".")) {
      return domain === allowedDomain;
    }
    // TLD match for generic domains like 'edu', 'gov'
    return domain.endsWith(`.${allowedDomain}`);
  });
};

// Function to get a user-friendly error message
export const getDomainError = (email: string): string => {
  const domain = email.split("@")[1];
  return `Email domain "${domain}" is not allowed. Please use an email from a verified institution or organization.`;
};
